/**
 * @generated SignedSource<<34336a48c12e5f565a3fa5a94778d366>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeScheduleShiftBar$data = {
  readonly durationSeconds: number;
  readonly formattedEndAtTime: string;
  readonly formattedStartAtTime: string;
  readonly scheduleType: {
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly secondaryScheduleType: {
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly startAtSecondsFromMidnight: number;
  readonly status: EmployeeShiftStatus;
  readonly " $fragmentType": "WidgetEmployeeScheduleShiftBar";
};
export type WidgetEmployeeScheduleShiftBar$key = {
  readonly " $data"?: WidgetEmployeeScheduleShiftBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleShiftBar">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeScheduleShiftBar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedStartAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedEndAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAtSecondsFromMidnight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "scheduleType",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleSecondaryType",
      "kind": "LinkedField",
      "name": "secondaryScheduleType",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "EmployeeShift",
  "abstractKey": null
};
})();

(node as any).hash = "55c9b63870b5404f5dd81537008e326e";

export default node;
